module.exports = __webpack_public_path__ + "img/hangye-bg.d01b0276.png";